export default __webpack_public_path__ + "static/media/ic_gmx_footer_.e7821eb2.svg";